import { useState } from "react";
import { Link } from "react-router-dom";
import { games, platformCategories } from "@/mocks/games";

const filters = ["全部", ...platformCategories.map((c) => c.name)];

export default function GameLibrary() {
  const [active, setActive] = useState("全部");

  const filtered =
    active === "全部" ? games : games.filter((g) => g.category === active);

  return (
    <section id="library" className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
      <div className="flex flex-col gap-2">
        <p className="text-xs font-semibold uppercase tracking-widest text-accent-500">
          Game Library
        </p>
        <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
          同人游戏资源库
        </h2>
        <p className="mt-2 max-w-2xl text-sm leading-7 text-foreground-600">
          精选多款火影同人游戏，支持按平台快速筛选。点击任意游戏可进入详情页，查看安装方式与启动指引。
        </p>
      </div>

      <div className="mt-8 flex flex-wrap items-center gap-3">
        {filters.map((f) => (
          <button
            key={f}
            type="button"
            onClick={() => setActive(f)}
            className={`whitespace-nowrap rounded-full px-5 py-2 text-sm font-medium transition-colors ${
              active === f
                ? "bg-primary-500 text-white"
                : "bg-background-100 text-foreground-600 hover:bg-secondary-100"
            }`}
          >
            {f}
          </button>
        ))}
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {filtered.map((game) => (
          <article
            key={game.slug}
            className="group flex flex-col overflow-hidden rounded-lg bg-background-100 border border-background-200 transition-all hover:-translate-y-1 hover:border-primary-200"
          >
            <Link to={`/game/${game.slug}`} className="relative block overflow-hidden">
              <img
                src={game.cover}
                alt={`${game.title}封面图`}
                title={`${game.title} 下载`}
                className="h-52 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-white">
                {game.category}
              </span>
              {game.noInstall && (
                <span className="absolute right-3 top-3 rounded-md bg-secondary-500 px-2.5 py-1 text-xs font-bold text-white">
                  免安装
                </span>
              )}
            </Link>

            <div className="flex flex-1 flex-col p-5">
              <h3 className="font-heading text-lg font-bold text-foreground-950">
                <Link to={`/game/${game.slug}`} className="transition-colors hover:text-primary-600">
                  {game.title}
                </Link>
              </h3>
              <p className="mt-2 line-clamp-2 flex-1 text-sm leading-6 text-foreground-600">
                {game.intro}
              </p>

              <div className="mt-4 flex flex-wrap items-center gap-2">
                {game.platform.map((p) => (
                  <span
                    key={p}
                    className="inline-flex items-center gap-1 rounded bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900"
                  >
                    <i className="ri-smartphone-line"></i>
                    {p}
                  </span>
                ))}
              </div>

              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4">
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-download-2-line text-primary-500"></i>
                    {game.downloads}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-star-fill text-amber-400"></i>
                    {game.rating}
                  </span>
                </div>
                <Link
                  to={`/game/${game.slug}`}
                  className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-3.5 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-primary-600"
                >
                  查看下载
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}